export const allCompanies = [
	'вк',
	'желтый банк',
	'яндекс',
	'авито',
	'озон',
	'сбер',
];
